"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chain = exports.AsyncRay = void 0;
const async_array_1 = require("./async_array");
const chainable_1 = require("./chainable");
/**
 * Get AsyncArray element
 *
 * @export
 * @template T
 * @param {...T[]} elements
 * @returns
 */
function AsyncRay(elements) {
    return new async_array_1.AsyncArray(...elements);
}
exports.AsyncRay = AsyncRay;
/**
 * Get chainable instance
 *
 * @export
 * @template T
 * @param {T[]} input
 * @returns
 */
function Chain(input) {
    return new chainable_1.Chainable(input);
}
exports.Chain = Chain;
__exportStar(require("./methods"), exports);
//# sourceMappingURL=index.js.map